import React, { Component } from "react";
import NoteTagList from "../../theme/buttons/NoteTag";
import { connect } from "react-redux";
import { setSessionVar } from "../../../store/actions";
import BaseModal from "../../theme/modals/BaseModal";

class DistrictTurfListItem extends Component {
  state = {
    confirmRemoveOpen: false,
  };
  onMouseEnter = () => {
    this.props.onMouseEnter && this.props.onMouseEnter();
  };

  onMouseLeave = () => {
    this.props.onMouseLeave && this.props.onMouseLeave();
  };

  handleZoomClick = (e) => {
    e.stopPropagation();
    const { onZoomToMap } = this.props;
    if (onZoomToMap) {
      onZoomToMap();
    }
  };

  handleRemoveClick = (e) => {
    e.stopPropagation();
    if (!this.props.onRemove) return;
    this.pendingRemoveEvent = e;
    this.setState({ confirmRemoveOpen: true });
  };

  onCloseConfirmRemove = () => {
    this.pendingRemoveEvent = null;
    this.setState({ confirmRemoveOpen: false });
  };

  handleConfirmRemove = () => {
    const { onRemove } = this.props;
    const e = this.pendingRemoveEvent;
    this.onCloseConfirmRemove();
    if (onRemove) {
      onRemove(e);
    }
  };

  renderDistictAggs = () => {
    let { data } = this.props;
    let cut_ratio =
      ((data.walkable_cut || 0) + (data.unwalkable_cut || 0)) /
      data.household_count;
    let attempt_ratio = (data.attempted || 0) / data.household_count;

    return (
      <>
        <div className="obj-data" data-attr="district-turf-counts">
          <span>
            <b>{data.household_count}</b> Doors, <b>{data.turf_count || 0}</b>{" "}
            Turfs
          </span>
        </div>
        <div className="obj-data" data-attr="district-turf-cut-stats">
          <span>
            <b className={cut_ratio > 0.98 ? "success-text" : "danger-text"}>
              {Math.round(cut_ratio * 100)}% cut
            </b>{" "}
            -- {data.walkable_cut || 0} walkable,{" "}
            <span className={data.unwalkable_cut > 0 ? "danger-text" : ""}>
              {data.unwalkable_cut || 0} not
            </span>
          </span>
        </div>
        {!!data.attempted && (
          <div className="obj-data" data-attr="district-turf-attempted">
            <span>
              <b className={"success-text"}>{data.attempted} attempted</b> (
              {Math.round(attempt_ratio * 100)}%)
            </span>
          </div>
        )}
        <div
          className={"clickable-children"}
          data-attr="district-turf-notes"
          onClick={(e) => {
            e.stopPropagation();
            this.props.setDistrictModalDistricts([data]);
          }}
        >
          <NoteTagList notes={data.notes} addButton />
        </div>
      </>
    );
  };

  renderTurfAggs = () => {
    let { data } = this.props;

    return (
      <>
        {!!data.household_count && (
          <>
            <div className="obj-data" data-attr="district-turf-counts">
              <span>
                <b>{data.household_count}</b> Doors
              </span>{" "}
              {!!data.target_count && (
                <span>
                  / <b>{data.target_count}</b> Targets
                </span>
              )}
            </div>
            {data.household_count_before_suppression &&
              data.household_count_before_suppression >
              data.household_count && (
                <div
                  className="obj-data danger-text"
                  data-attr="district-turf-suppressed"
                >
                  <span>
                    <i
                      className="fas fa-exclamation-triangle"
                      style={{ paddingRight: ".5em" }}
                    />
                    <b>
                      {data.household_count_before_suppression -
                        data.household_count}
                    </b>{" "}
                    Doors Suppressed
                  </span>
                </div>
              )}
          </>
        )}
        {!!data.agg_data && (
          <div
            className="obj-data primary-text"
            data-attr="district-turf-attempted"
          >
            {data.agg_data.households_attempted} doors /{" "}
            {data.agg_data.targets_attempted} targets attempted.
          </div>
        )}
        {!!data.code_name && (
          <div className="obj-data" data-attr="district-turf-code-name">
            {data.code_name}
          </div>
        )}
        {/* data.notes has been deprecated, to remove in a future release. We now use notes below.*/}
        <div
          className={"clickable-children"}
          data-attr="district-turf-notes"
          onClick={(e) => {
            // e.stopPropagation();
            this.props.setTurfModalTurfs([data]);
          }}
        >
          <NoteTagList notes={data.turfnotes} addButton />
        </div>
      </>
    );
  };

  renderConfirmRemoveModal = () => {
    const { data, isDistrict } = this.props;
    const kind = isDistrict ? "district" : "turf";
    const confirmLabel = isDistrict ? "Remove" : "Delete";

    return (
      <BaseModal
        open={this.state.confirmRemoveOpen}
        onClose={this.onCloseConfirmRemove}
        center
      >
        <div
          className="modal-internal-wrapper"
          data-attr="district-turf-remove-confirm-modal"
        >
          <p>
            {isDistrict ? (
              <>
                Are you sure you want to remove{" "}
                {data.name ? <b>{data.name}</b> : `this ${kind}`} from the
                selection?
              </>
            ) : (
              <>
                Are you sure you want to delete{" "}
                {data.name ? <b>{data.name}</b> : `this ${kind}`}?
              </>
            )}
          </p>
          <div className="button-wrapper">
            <div
              className="button"
              data-attr="district-turf-remove-confirm"
              onClick={this.handleConfirmRemove}
            >
              {confirmLabel}
            </div>
            <div
              className="button button-outline"
              data-attr="district-turf-remove-cancel"
              onClick={this.onCloseConfirmRemove}
            >
              Cancel
            </div>
          </div>
        </div>
      </BaseModal>
    );
  };

  render() {
    let { data, focused, selected } = this.props;
    const showCheckbox = typeof selected === "boolean";

    return (
      <div
        className={`side-menu-list-obj district district-turf-list-item ${focused ? "focused" : ""
          } ${showCheckbox && selected ? "district-turf-list-item--selected" : ""}`}
        data-component="DistrictTurfListItem"
        data-attr="district-turf-list-item"
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        id={data.id}
        onClick={this.props.onClick}
        onDoubleClick={this.props.onDoubleClick}
      >
        {/*inner wrapper to generate side color border*/}
        <div
          className="list-obj-inner-wrapper"
          style={
            this.props.color
              ? {
                  borderLeftColor: this.props.color,
                  "--district-turf-accent": this.props.color,
                }
              : undefined
          }
        >
          <div
            className="obj-title district-turf-list-item__title"
            data-attr="district-turf-title"
          >
            {showCheckbox && (
              <span
                className="district-turf-list-item__checkbox"
                data-attr="district-turf-checkbox"
                aria-hidden="true"
              >
                <i
                  className={
                    selected ? "fas fa-check-square" : "far fa-square"
                  }
                />
              </span>
            )}
            <span
              className="district-turf-list-item__name"
              data-attr="district-turf-name"
            >
              {data.name}
            </span>
            {(this.props.onZoomToMap || this.props.onRemove) && (
              <span className="district-turf-list-item__title-actions">
                {this.props.onZoomToMap && (
                  <i
                    className="district-turf-list-item__zoom fas fa-search-plus"
                    data-attr="district-turf-zoom"
                    title="Center map on this item"
                    aria-label="Center map on this item"
                    onClick={this.handleZoomClick}
                  />
                )}
                {this.props.onRemove && (
                  <i
                    className="district-turf-list-item__remove remove-seat-icon far fa-times-circle"
                    data-attr="district-turf-remove"
                    onClick={this.handleRemoveClick}
                  />
                )}
              </span>
            )}
          </div>

          {/*THIS IS DISTRICT SPECIFIC*/}
          {!!this.props.isDistrict && this.renderDistictAggs()}

          {/*THIS IS TURF SPECIFIC*/}
          {!this.props.isDistrict && this.renderTurfAggs()}
        </div>
        {this.renderConfirmRemoveModal()}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setDistrictModalDistricts: (district) =>
    dispatch(setSessionVar("districtNoteModalDistricts", district)),
  setTurfModalTurf: (turf) =>
    dispatch(setSessionVar("turfNoteModalTurf", turf)),
});

export default connect(null, mapDispatchToProps)(DistrictTurfListItem);
